import {
  EntityType,
  EntityHistoryResponse,
  EntityTransitionsResponse,
  EntityHistory,
  VersionComparison,
  StatusTransition,
} from 'shared';
import { apiService } from './api.service';

export const historyService = {
  /**
   * Get all history versions for an entity
   */
  async getHistory(
    entityType: EntityType,
    entityId: string
  ): Promise<EntityHistoryResponse> {
    return apiService.get(`/history/${entityType}/${entityId}`);
  },

  /**
   * Get a specific version of an entity
   */
  async getVersion(
    entityType: EntityType,
    entityId: string,
    version: number
  ): Promise<EntityHistory> {
    return apiService.get(
      `/history/${entityType}/${entityId}/version/${version}`
    );
  },

  /**
   * Compare two versions of an entity
   */
  async compareVersions(
    entityType: EntityType,
    entityId: string,
    version1: number,
    version2: number
  ): Promise<VersionComparison> {
    return apiService.get(
      `/history/${entityType}/${entityId}/compare?v1=${version1}&v2=${version2}`
    );
  },

  /**
   * Get all status transitions for an entity
   */
  async getTransitions(
    entityType: EntityType,
    entityId: string
  ): Promise<EntityTransitionsResponse> {
    return apiService.get(`/history/${entityType}/${entityId}/transitions`);
  },

  /**
   * Create a new status transition
   */
  async createTransition(data: {
    entityType: EntityType;
    entityId: string;
    fromStatus: string;
    toStatus: string;
    comment?: string;
  }): Promise<StatusTransition> {
    return apiService.post('/history/transitions', data);
  },
};
